import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../axiosInstance/axiosInstance";
import { ApiErrorResponse } from "../../../api/types/ApiErrorResponse";
import { toApiError } from "../../../api/utils/errorHandling";
import { BusinessProfileResponse } from "../contracts/BusinessProfileResponse";
import { UpdateBusinessProfileRequest } from "../contracts/UpdateBusinessProfileRequest";
import { mapResponseToBusinessProfile } from "../mappers/BusinessProfileResponseMapper";
import { BusinessProfile } from "../models/BusinessProfile";

const BASE = "/billing/business-profile";

export const fetchBusinessProfile = createAsyncThunk<
  BusinessProfile,
  void,
  { rejectValue: ApiErrorResponse }
>("businessProfile/fetch", async (_, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get<BusinessProfileResponse>(BASE);
    return mapResponseToBusinessProfile(response.data);
  } catch (error) {
    return rejectWithValue(toApiError(error, "Failed to load business details"));
  }
});

export const updateBusinessProfile = createAsyncThunk<
  BusinessProfile,
  UpdateBusinessProfileRequest,
  { rejectValue: ApiErrorResponse }
>("businessProfile/update", async (request, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.put<BusinessProfileResponse>(BASE, request);
    return mapResponseToBusinessProfile(response.data);
  } catch (error) {
    return rejectWithValue(toApiError(error, "Failed to save business details"));
  }
});
